import styles from '@ui/components/Skeleton/Skeleton.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Skeleton = ({
  height = null,
  width = null,
  count = 1,
  className = null,
  children,
}) => {
  const styleHeight = height ? { height: `${height}` } : {};

  return (
    <>
      {Array.from(Array(count).keys()).map(i => (
        <div
          className={classNames(styles.container, className)}
          data-purpose="skeleton"
          key={`skeleton_${width}_${height}_${i}`}
          style={{ ...styleHeight, width: `${width}` }}
        >
          {children}
        </div>
      ))}
    </>
  );
};

Skeleton.propTypes = {
  className: PropTypes.string,
  /** Number of skeletons that will get generated */
  count: PropTypes.number,
  /** Width of skeleton (in px, em, rem, etc.) */
  height: PropTypes.string,
  /** Height of skeleton (in px, em, rem, etc.) */
  width: PropTypes.string,
};

export default Skeleton;
